import React from 'react'

import type { DialogProps } from '@paintscout/ui'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TileList,
  useDialogs,
  IconButton
} from '@paintscout/ui'
import { makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

export interface TileListDialogProps extends DialogProps {
  title: string
  items: {
    key: string
    label: string
    subLabel?: string
  }[]
  onItemSelect: (key: string) => void
}

const useStyles = makeStyles((theme) => ({
  content: {
    paddingBottom: 0
  },
  tileList: {
    paddingTop: theme.spacing(1)
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dialogPaper: {
    '& .MuiDialogActions-root': {
      display: 'none !important'
    },
    '& .MuiDialogContent-root': {
      paddingBottom: `${theme.spacing(3)}px !important`
    }
  }
}))

export default function TileListDialog({ title, items, onItemSelect, loading, ...otherProps }: TileListDialogProps) {
  const classes = useStyles()
  const { dismissDialog } = useDialogs()
  const isAddRequestPayment = title === 'Add/Request Payment'

  return (
    <Dialog
      {...otherProps}
      maxWidth={'md'}
      fullWidth={true}
      classes={isAddRequestPayment ? { paper: classes.dialogPaper } : undefined}
    >
      <DialogTitle
        loading={loading}
        classes={isAddRequestPayment ? { root: classes.dialogTitle } : undefined}
        rightContent={
          isAddRequestPayment ? (
            <IconButton size="small" onClick={dismissDialog} disabled={loading}>
              <CloseIcon />
            </IconButton>
          ) : undefined
        }
      >
        {title}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.tileList}>
          <TileList
            items={items}
            onSelect={(_, key) => {
              onItemSelect(key as string)
            }}
            subLabelField="subLabel"
          />
        </div>
      </DialogContent>
      {!isAddRequestPayment && (
        <DialogActions
          leftButton={
            <Button onClick={dismissDialog} variant="textNoPadding">
              Cancel
            </Button>
          }
        />
      )}
    </Dialog>
  )
}
